import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useState, useRef, useCallback, useContext } from 'react';
import ddt from '@wix/da-ddt';
import { useStore } from 'react-redux';
import { runSaga } from 'redux-saga';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
/* TODO while this is clever it doesn't follow our general workflow, we should tidy up
and just use normal saga/redux if we do need something like this it should be more like
useStream */ function useRequestSagaAsPromise(runSagaOptions = {}) {
    const store = useStore();
    return (options, fake)=>runSaga(_object_spread({
            getState () {
                return store.getState();
            }
        }, runSagaOptions), requestPuppy, options, fake).toPromise();
}
const logger = ddt.createLogger('topics');
const TOPIC_SETTING_ENDPOINT = '/topic/setting';
export const InjectedRequestFnContext = React.createContext(undefined);
/** Fetches the current watch level of the given topicId */ export default function useFetchedTopicWatchLevel(topicId) {
    const sagaRequest = useRequestSagaAsPromise();
    const injectedRequestFn = useContext(InjectedRequestFnContext);
    const [topicWatchLevel, setTopicWatchLevel] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    // shouldn't be necessary - just an extra guard rail
    const hasTriedOnce = useRef(false);
    const wrappedFetchTopicWatchLevel = useCallback(()=>{
        if (isLoading || topicWatchLevel || !!error || hasTriedOnce.current) {
            return;
        }
        (async function fetchWrapper() {
            try {
                setIsLoading(true);
                hasTriedOnce.current = true;
                const response = await (injectedRequestFn ? injectedRequestFn(topicId) : sagaRequest({
                    method: 'get',
                    url: TOPIC_SETTING_ENDPOINT,
                    params: {
                        necoid: topicId
                    }
                }, fakeFetchTopicWatchLevel));
                if (!response) {
                    throw new Error(`unknown error fetching topic: ${topicId}`);
                }
                response.userTopicSubscription && setTopicWatchLevel(response.userTopicSubscription);
            } catch (caughtError) {
                logger.error('error fetching topic watch level', {
                    topicId
                }, error);
                setError(caughtError);
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        injectedRequestFn,
        topicId,
        topicWatchLevel,
        isLoading,
        error,
        sagaRequest
    ]);
    return {
        fetchTopicWatchLevel: wrappedFetchTopicWatchLevel,
        topicWatchLevel,
        isLoading,
        error
    };
}
const FAKE_USER_TOPIC_SUBSCRIPTION = 'not-watching';
// const FAKE_USER_TOPIC_SUBSCRIPTION = 'watching';
// const FAKE_USER_TOPIC_SUBSCRIPTION = 'suppressed';
function fakeFetchTopicWatchLevel() {
    if (process.env.NODE_ENV !== 'production') {
        if (typeof window !== 'undefined' && window.doError) {
            throw new Error('invalid_request');
        }
        return {
            userTopicSubscription: FAKE_USER_TOPIC_SUBSCRIPTION
        };
    }
}

//# sourceMappingURL=useFetchedTopicWatchLevel.js.map